// @core/api/endpoints/secret/renew_lease.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LeaseResponse,
  RenewLeaseRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Renew lease
 * Extends the TTL of an active lease. The new TTL cannot exceed the lease's max_ttl_seconds. Non-renewable leases will return an error.
 */
export async function RenewLease(
  lease_id: string,
  data: RenewLeaseRequest,
  options?: RequestOptions
): Promise<LeaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/leases/:lease_id/renew`;
  requestPath = requestPath.replace(':lease_id', encodeURIComponent(lease_id));
  const requestOptions = options;
  return client.post<LeaseResponse>(requestPath, data, requestOptions);
}
